export const SNACKBAR_INIT = {
    isOpen: false,
    variant: '',
    message: ''
}
export const SNACKBAR_OPEN = 'SNACKBAR_OPEN'
export const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE'
export const SNACKBAR_OPENAPI = 'SNACKBAR_OPENAPI'
